import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=14af561a&scoped=true&"
import script from "./LegalInfo.vue?vue&type=script&lang=js&"
export * from "./LegalInfo.vue?vue&type=script&lang=js&"
import style0 from "./LegalInfo.vue?vue&type=style&index=0&id=14af561a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14af561a",
  null
  
)

export default component.exports